"use client";

/* eslint-disable @typescript-eslint/no-explicit-any */
import { createContext } from "react";
import type { MessageApi, MessageOpts, MessageTexts, Notify } from "./types";

export const Ctx = createContext<MessageApi | null>(null);

export function createNotify(api: MessageApi): Notify {
    const open = (
        type: "success" | "error" | "warning" | "info" | "loading",
        content?: React.ReactNode,
        opts?: MessageOpts,
    ) => api.open({ type, content, ...opts });

    const parseError = (e: unknown): string => {
        if (typeof e === "string") return e;
        if (e && typeof e === "object") {
            const any = e as any;
            if (any.message) return String(any.message);
            if (any.detail) {
                if (any.detail === "LOGIN_BAD_CREDENTIALS") return "Неверный логин или пароль";
                else if (any.detail === "REGISTER_USER_ALREADY_EXISTS")
                    return "Пользователь с таким e-mail уже существует";

                return Array.isArray(any.detail)
                    ? any.detail
                          .map((d: any) => d.msg || d.detail || d.message || "")
                          .filter(Boolean)
                          .join("; ")
                    : String(any.detail);
            }
            if (any.error) return String(any.error);
        }
        return "Произошла ошибка. Попробуйте ещё раз.";
    };

    return {
        success: (c, o) => open("success", c, o),
        error: (c, o) => open("error", c, o),
        warning: (c, o) => open("warning", c, o),
        info: (c, o) => open("info", c, o),
        loading: (c = "Загрузка…", o) => open("loading", c, o),

        apiError: (err, fallback, opts) => {
            open("error", parseError(err) || fallback || "Ошибка запроса", opts);
        },

        async promise<T>(p: Promise<T>, texts?: MessageTexts, opts?: MessageOpts) {
            const key = opts?.key ?? "msg";
            open("loading", texts?.loading ?? "Загрузка…", { ...opts, key });
            try {
                const res = await p;
                open("success", texts?.success ?? "Готово", { ...opts, key });
                return res;
            } catch (e) {
                open("error", texts?.error ?? parseError(e), { ...opts, key });
                throw e;
            }
        },
    };
}
